import { ModelType } from '@biteinc/enums';
import { biteSettingsSchema } from '../models/settings_bite_schema.js';
import { commonSettingsSchema } from '../models/settings_common_schema.js';
import { flashSettingsSchema } from '../models/settings_flash_schema.js';
import { kioskSettingsSchema } from '../models/settings_kiosk_schema.js';
import { menuAppearanceSettingsSchema } from '../models/settings_menu_appearance_schema.js';
import { receiptSettingsSchema } from '../models/settings_receipt_schema.js';
import { recommendationSettingsSchema } from '../models/settings_recommendations_schema.js';
/**
 * @todo
 * Remove this helper method when all clients are on a supported GCN version which uses the new settings schema.
 */
export function getSchemaFieldsForModelType(modelType) {
    switch (modelType) {
        case ModelType.Menu:
            return Object.keys(menuAppearanceSettingsSchema);
        case ModelType.Location:
            return [
                ...Object.keys(biteSettingsSchema),
                ...Object.keys(commonSettingsSchema),
                ...Object.keys(flashSettingsSchema),
                ...Object.keys(kioskSettingsSchema),
                ...Object.keys(receiptSettingsSchema),
                ...Object.keys(recommendationSettingsSchema),
            ];
    }
}
export function getSchemaFieldForAllSettingsSubSchemas() {
    return [
        ...Object.keys(biteSettingsSchema),
        ...Object.keys(commonSettingsSchema),
        ...Object.keys(flashSettingsSchema),
        ...Object.keys(kioskSettingsSchema),
        ...Object.keys(receiptSettingsSchema),
        ...Object.keys(menuAppearanceSettingsSchema),
        ...Object.keys(recommendationSettingsSchema),
    ];
}
export function getSchemaFieldsForSettingsSubSchema(schemaName, excludeKeys = []) {
    const keysTopCopy = [];
    switch (schemaName) {
        case 'bite':
            keysTopCopy.push(...Object.keys(biteSettingsSchema));
            break;
        case 'common':
            keysTopCopy.push(...Object.keys(commonSettingsSchema));
            break;
        case 'flash':
            keysTopCopy.push(...Object.keys(flashSettingsSchema));
            break;
        case 'kiosk':
            keysTopCopy.push(...Object.keys(kioskSettingsSchema));
            break;
        case 'receipt':
            keysTopCopy.push(...Object.keys(receiptSettingsSchema));
            break;
        case 'appearance':
            keysTopCopy.push(...Object.keys(menuAppearanceSettingsSchema));
            break;
        case 'recommendations':
            keysTopCopy.push(...Object.keys(recommendationSettingsSchema));
            break;
    }
    return keysTopCopy.filter((key) => !excludeKeys.includes(key));
}
//# sourceMappingURL=get_settings_properties_for_models.js.map